module.exports = __webpack_public_path__ + "img/error.02be7e79.svg";